import { render } from "./list-category.vue?vue&type=template&id=2ed9d1cd"
import script from "./list-category.vue?vue&type=script&lang=js"
export * from "./list-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__